<template>
  <div class="pv-root" :class="{ 'pv-selecting': selecting }">
    <!-- Banner de seleção -->
    <div v-if="selecting" class="pv-selecting-banner">
      <fa-icon icon="hand-pointer" /> Selecione um componente
    </div>

    <div class="pv-search">
      <fa-icon icon="search" class="pv-search-icon" />
      <input type="text" v-model="filtro" placeholder="Buscar..." />
    </div>

    <!-- VARIÁVEIS DO ITEM -->
    <div class="pv-section" v-if="variaveisItem.length > 0">
      <div class="pv-section-label">VARIÁVEIS DO ITEM</div>
      <div class="pv-grid">
        <div
          v-for="v in variaveisItem"
          :key="v.chave"
          class="pv-node"
          :class="[selecting ? 'pv-node-selectable' : '']"
          draggable="true"
          @dragstart="onDrag($event, v.chave)"
          @click="onSelect(v.chave)"
          :title="v.nome"
        >
          <div class="pv-node-box" :class="'pv-box-' + v.tipo">
            {{ initials(v.nome) }}
          </div>
          <span class="pv-node-label">{{ v.nome }}</span>
        </div>
      </div>
    </div>

    <!-- VARIÁVEIS DO ORÇAMENTO -->
    <div class="pv-section" v-if="variaveisOrcamento.length > 0">
      <div class="pv-section-label">VARIÁVEIS DO ORÇAMENTO</div>
      <div class="pv-grid">
        <div
          v-for="v in variaveisOrcamento"
          :key="v.chave"
          class="pv-node"
          :class="[selecting ? 'pv-node-selectable' : '']"
          draggable="true"
          @dragstart="onDrag($event, v.chave)"
          @click="onSelect(v.chave)"
          :title="v.nome"
        >
          <div class="pv-node-box" :class="'pv-box-' + v.tipo">
            {{ initials(v.nome) }}
          </div>
          <span class="pv-node-label">{{ v.nome }}</span>
        </div>
      </div>
    </div>

    <!-- OPERADORES -->
    <div class="pv-section" v-if="operadoresFiltrados.length > 0">
      <div class="pv-section-label">OPERADORES</div>
      <div class="pv-grid">
        <div
          v-for="op in operadoresFiltrados"
          :key="op.val"
          class="pv-node"
          :class="[selecting ? 'pv-node-selectable' : '']"
          draggable="true"
          @dragstart="onDrag($event, op.val)"
          @click="onSelect(op.val)"
          :title="op.label"
        >
          <div class="pv-node-box pv-box-op">{{ op.display }}</div>
          <span class="pv-node-label">{{ op.label }}</span>
        </div>
      </div>
    </div>

    <!-- VALOR FIXO -->
    <div class="pv-section" v-if="!filtro || 'valor fixo constante numero'.includes(filtro.toLowerCase())">
      <div class="pv-section-label">VALOR FIXO</div>
      <div class="pv-grid">
        <div
          class="pv-node"
          :class="[selecting ? 'pv-node-selectable' : '']"
          draggable="true"
          @dragstart="onDrag($event, ' 0 ')"
          @click="onSelect(' 0 ')"
          title="Arraste e edite o valor na fórmula"
        >
          <div class="pv-node-box pv-box-num">0</div>
          <span class="pv-node-label">Valor fixo</span>
        </div>
      </div>
    </div>

    <!-- RESULTADOS -->
    <div class="pv-section" v-if="resultadosFiltrados.length > 0">
      <div class="pv-section-label">RESULTADOS</div>
      <div class="pv-grid">
        <div
          v-for="res in resultadosFiltrados"
          :key="res"
          class="pv-node"
          :class="[selecting ? 'pv-node-selectable' : '']"
          draggable="true"
          @dragstart="onDrag($event, res)"
          @click="onSelect(res)"
          :title="variaveisMap[res] || res"
        >
          <div class="pv-node-box pv-box-result">{{ initials(variaveisMap[res] || res) }}</div>
          <span class="pv-node-label">{{ variaveisMap[res] || res }}</span>
        </div>
      </div>
    </div>

    <!-- Nada encontrado -->
    <div class="pv-empty" v-if="filtro && variaveisFiltradas.length === 0 && operadoresFiltrados.length === 0 && resultadosFiltrados.length === 0">
      Nenhum resultado para "{{ filtro }}"
    </div>
  </div>
</template>

<script>
export default {
  name: "PainelVariaveis",
  props: {
    variaveis: { type: Array, default: () => [] },
    resultadosDisponiveis: { type: Array, default: () => [] },
    variaveisMap: { type: Object, default: () => ({}) },
    selecting: { type: Boolean, default: false },
  },
  data() {
    return {
      filtro: "",
      operadores: [
        { val: " + ", display: "+", label: "Soma" },
        { val: " - ", display: "−", label: "Subtração" },
        { val: " * ", display: "×", label: "Multiplicação" },
        { val: " / ", display: "÷", label: "Divisão" },
        { val: "(", display: "(", label: "Abre parêntese" },
        { val: ")", display: ")", label: "Fecha parêntese" },
      ],
    };
  },
  computed: {
    variaveisFiltradas() {
      if (!this.filtro) return this.variaveis;
      const f = this.filtro.toLowerCase();
      return this.variaveis.filter(
        (v) => v.nome.toLowerCase().includes(f) || v.chave.toLowerCase().includes(f)
      );
    },
    variaveisItem() {
      return this.variaveisFiltradas.filter((v) => v.escopo !== 'orcamento');
    },
    variaveisOrcamento() {
      return this.variaveisFiltradas.filter((v) => v.escopo === 'orcamento');
    },
    operadoresFiltrados() {
      if (!this.filtro) return this.operadores;
      const f = this.filtro.toLowerCase();
      return this.operadores.filter(
        (op) => op.label.toLowerCase().includes(f) || op.display.includes(f) || op.val.trim().includes(f)
      );
    },
    resultadosFiltrados() {
      if (!this.filtro) return this.resultadosDisponiveis;
      const f = this.filtro.toLowerCase();
      return this.resultadosDisponiveis.filter((r) => r.toLowerCase().includes(f));
    },
  },
  methods: {
    initials(nome) {
      const words = nome.split(/[\s_]+/).filter(Boolean);
      const stopWords = ['de', 'do', 'da', 'dos', 'das'];
      const meaningful = words.filter((w) => !stopWords.includes(w.toLowerCase()));
      if (meaningful.length >= 3) {
        return (meaningful[0][0] + meaningful[meaningful.length - 1][0]).toUpperCase();
      }
      if (meaningful.length === 2) return (meaningful[0][0] + meaningful[1][0]).toUpperCase();
      if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
      return nome.substring(0, 2).toUpperCase();
    },
    onDrag(e, val) {
      e.dataTransfer.setData("text/plain", val);
      e.dataTransfer.effectAllowed = "copy";
      const box = e.target.closest('.pv-node')?.querySelector('.pv-node-box');
      if (box) {
        e.dataTransfer.setDragImage(box, 24, 24);
      }
    },
    onSelect(val) {
      this.$emit("inserir", val);
    },
  },
};
</script>

<style scoped>
.pv-root {
  display: flex; flex-direction: column; gap: 12px; height: 100%;
}
.pv-selecting { }

.pv-search { position: relative; }
.pv-search-icon {
  position: absolute; left: 8px; top: 50%; transform: translateY(-50%);
  color: #d1d5db; font-size: 0.65rem;
}
.pv-search input {
  width: 100%; padding: 6px 8px 6px 26px;
  border: 1.5px solid #e5e7eb; border-radius: 8px;
  font-size: 0.72rem; outline: none; background: #fff;
}
.pv-search input:focus { border-color: #818cf8; }
.pv-search input::placeholder { color: #d1d5db; }

.pv-section { flex-shrink: 0; }
.pv-section-label {
  font-size: 0.55rem; font-weight: 800; letter-spacing: 1.5px;
  color: #9ca3af; margin-bottom: 6px;
}

.pv-grid {
  display: grid; grid-template-columns: repeat(2, 1fr);
  gap: 6px;
}

.pv-node {
  display: flex; flex-direction: column; align-items: center;
  gap: 3px; cursor: grab; user-select: none;
  transition: all 0.15s;
}
.pv-node:active { cursor: grabbing; }

/* Modo seleção: cursor pointer nos cards */
.pv-node-selectable { cursor: pointer; }
.pv-node-selectable:hover .pv-node-box {
  transform: translateY(-2px) scale(1.05);
}

.pv-node-box {
  width: 48px; height: 48px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  border: 1.5px solid #e5e7eb; background: #fff;
  font-size: 0.75rem; font-weight: 800; color: #374151;
  transition: all 0.15s;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
}
.pv-node-box:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}
.pv-node-label {
  font-size: 0.55rem; color: #6b7280; text-align: center;
  max-width: 84px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}

.pv-box-valor { border-color: #a7f3d0; background: linear-gradient(135deg, #ecfdf5, #d1fae5); color: #065f46; }
.pv-box-percentual { border-color: #fdba74; background: linear-gradient(135deg, #fff7ed, #ffedd5); color: #9a3412; }
.pv-box-quantidade { border-color: #93c5fd; background: linear-gradient(135deg, #eff6ff, #dbeafe); color: #1e40af; }
.pv-box-fator { border-color: #c4b5fd; background: linear-gradient(135deg, #f5f3ff, #ede9fe); color: #5b21b6; }
.pv-box-op { border-color: #ddd6fe; background: linear-gradient(135deg, #f5f3ff, #ede9fe); color: #7c3aed; font-size: 1.1rem; }
.pv-box-result { border-color: #c7d2fe; background: linear-gradient(135deg, #eef2ff, #e0e7ff); color: #4338ca; }

.pv-box-num { border-color: #fde68a; background: linear-gradient(135deg, #fefce8, #fef3c7); color: #92400e; font-family: 'SF Mono', monospace; font-size: 0.9rem; }

.pv-empty {
  text-align: center; padding: 16px; color: #9ca3af; font-size: 0.75rem;
}
.pv-selecting-banner {
  display: flex; align-items: center; justify-content: center; gap: 6px;
  padding: 8px 10px; border-radius: 8px;
  background: #10b981; color: #fff;
  font-size: 0.72rem; font-weight: 600;
  animation: bannerPulse 1s ease-in-out infinite;
}
@keyframes bannerPulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(16,185,129,0.3); }
  50% { box-shadow: 0 0 12px rgba(16,185,129,0.4); }
}
</style>
